module.exports = __webpack_public_path__ + "static/media/gemini_logo.363426f6.svg";